'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PrintIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PrintIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Print-Text--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Print Text Streamline Icon: https://streamlinehq.com</desc>
        <defs></defs>
        <title>print-text</title>
        <path
          d="m7.5 19.499 9 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m7.5 16.499 9 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M5.5 16.5h-3a2.006 2.006 0 0 1 -2 -2v-6a2.006 2.006 0 0 1 2 -2h19a2.006 2.006 0 0 1 2 2v6a2.006 2.006 0 0 1 -2 2h-3"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M5.5 4.5v-4h9.586a1 1 0 0 1 0.707 0.293l2.414 2.414a1 1 0 0 1 0.293 0.707V4.5"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M18.5 22.5a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1 -1v-9h13Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M2.5 9.499a1 1 0 1 0 2 0 1 1 0 1 0 -2 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14.5 0.499 0 4 4 0"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

PrintIcon.propTypes = {
  sx: PropTypes.object
}
